import { React, useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import ArabicKeyboardPopup from './keyboardpopup';
import { FaKeyboard } from 'react-icons/fa';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import LeaseApiService from '../../services/apiService';

const PersonalDetails = ({
  tableLoading,
  readOnly = false,
  nationalityList,
  setSelectedCity,
  handleCountryChange,
  countriesList,
  cityList,
  setTransectionData,
  titleList,
  packageName,
  categoryMix,
  transectionData,
  leadType,
  agentList,
  selectedCountry,
  selectedCity,
  customerTypeList,
  salesPersonList,
  leadStatus,
  defaultCountry,
}) => {
  const apiService = new LeaseApiService();
  const [activeField, setActiveField] = useState(null);
  const genderOptions = [
    { value: 'M', label: 'Male' },
    { value: 'F', label: 'Female' },
    { value: 'O', label: 'Other' },
  ];
  const handleDateChange = async (input) => {
    const name = input?.target?.name || input.name;
    const value = input?.target?.value || input.value;
    setTransectionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleInputChange = (input) => {
    const name = input?.target?.name || input.name;
    const value = input?.target?.value || input.value;

    setTransectionData((prev) => {
      const updatedData = { ...prev, [name]: value };
      if (name === 'firstName' || name === 'lastName') {
        updatedData.fullName = `${updatedData.firstName || ''} ${updatedData.lastName || ''}`.trim();
      }
      return updatedData;
    });
  };
  const handleDropDownChange = async ({ name, value }) => {
    setTransectionData((prev) => ({ ...prev, [name]: value }));
  };
  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
  };
  const handleKeyboardChange = (value) => {
    setTransectionData((prev) => ({
      ...prev,
      [activeField]: value,
    }));
  };
  return (
    <div className="cost-center-section my-3">
      <div className={`border-box2 p-3`}>
        {tableLoading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
            }}
          >
            <div className="spinner-border text-primary" role="status" />
          </div>
        )}
        <div className="form-group grid-contain ">
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Type *
            </label>
            <Select
              className="p-0 w-100"
              isDisabled={readOnly}
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData.type}
              onChange={(selectedOption) => handleDropDownChange({ name: 'type', value: selectedOption })}
              options={customerTypeList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Mobile No *
            </label>
            <div style={{ width: '100%' }}>
              <PhoneInput
                country={defaultCountry}
                value={transectionData.mobileNo}
                disabled={readOnly}
                onChange={(value, country) => {
                  setTransectionData((prev) => ({
                    ...prev,
                    mobileNo: value,
                    countryCode: country,
                  }));
                }}
                enableSearch
              />
            </div>
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom18" className="form-label">
              Nationality
            </label>
            <Select
              className="p-0 w-100"
              isDisabled={readOnly}
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.nationality}
              onChange={(selectedOption) => handleDropDownChange({ name: 'nationality', value: selectedOption })}
              options={nationalityList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Title *
            </label>
            <Select
              className="p-0 w-100"
              isDisabled={readOnly}
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData.title}
              onChange={(selectedOption) => handleDropDownChange({ name: 'title', value: selectedOption })}
              options={titleList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Email ID
            </label>
            <input
              type="email"
              readOnly={readOnly}
              className="p-2 form-control w-75"
              value={transectionData?.email}
              onChange={handleInputChange}
              name="email"
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Phone No{' '}
            </label>
            <div style={{ width: '75%' }}>
              <PhoneInput
                className="p-0"
                country={defaultCountry}
                value={transectionData.phoneNo}
                disabled={readOnly}
                onChange={(value, country) => {
                  setTransectionData((prev) => ({
                    ...prev,
                    phoneNo: value,
                    countryCode: country,
                  }));
                }}
                enableSearch
              />
            </div>
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              First Name
            </label>
            <input
              type="text"
              readOnly={readOnly}
              className="p-2 form-control w-75"
              value={transectionData?.firstName}
              onChange={handleInputChange}
              name="firstName"
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom18" className="form-label">
              Country
            </label>
            <Select
              className="p-0 w-100"
              isDisabled={readOnly}
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={selectedCountry}
              onChange={handleCountryChange}
              options={countriesList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Address{' '}
            </label>
            <input
              type="text"
              readOnly={readOnly}
              className="p-2 form-control w-75"
              value={transectionData?.address}
              onChange={handleInputChange}
              name="address"
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Last Name
            </label>
            <input
              type="text"
              readOnly={readOnly}
              className="p-2 form-control w-75"
              value={transectionData?.lastName}
              onChange={handleInputChange}
              name="lastName"
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              City
            </label>
            <Select
              className="p-0 w-100"
              isDisabled={readOnly}
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={selectedCity}
              onChange={handleCityChange}
              options={cityList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              P.O.Box{' '}
            </label>
            <input type="text" readOnly={readOnly} className="p-2 form-control w-75" value={transectionData?.poBox} onChange={handleInputChange} name="poBox" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Full Name *
            </label>
            <input type="text" className="p-2 form-control w-75" value={`${transectionData?.fullName || ''}`} readOnly name="stayedPeriod" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Gender
            </label>
            <Select
              className="p-0 w-100"
              isDisabled={readOnly}
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.gender}
              onChange={(selectedOption) => handleDropDownChange({ name: 'gender', value: selectedOption })}
              options={genderOptions?.map((country) => ({ value: country, label: country?.label }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Date of Birth
            </label>
            <DatePicker
              todayButton="Today"
              readOnly={readOnly}
              selected={transectionData?.dateofBirth}
              onChange={(date) => handleDateChange({ name: 'dateofBirth', value: date })}
              dateFormat="dd-MMM-yyyy"
              className="p-2 form-control w-100"
            />
          </div>
          <div className="d-flex align-items-center">
            {transectionData?.type?.label === 'Company' || transectionData?.type?.label === 'Government' ? (
              <label className="form-label w-25">CO. Name (AR)</label>
            ) : (
              <label className="form-label w-25">FirstName (AR)</label>
            )}
            <input
              type="text"
              dir="rtl"
              lang="ar"
              className="form-control"
              readOnly={readOnly}
              value={transectionData.firstNameAR}
              onChange={(e) =>
                setTransectionData((prev) => ({
                  ...prev,
                  firstNameAR: e.target.value,
                }))
              }
              onFocus={() => !readOnly && setActiveField('firstNameAR')}
            />

            <FaKeyboard
              size={30}
              className="ms-2 keyboard-icon"
              style={{ cursor: readOnly ? 'not-allowed' : 'pointer', opacity: readOnly ? 0.45 : 1 }}
              onClick={() => !readOnly && setActiveField('firstNameAR')}
            />
          </div>
          {/* Last Name AR */}

          {transectionData?.type?.label === 'Company' || transectionData?.type?.label === 'Government' ? (
            <div></div>
          ) : (
            <div className="d-flex align-items-center mt-3">
              <label className="form-label w-25">LastName (AR)</label>

              <input
                type="text"
                className="form-control"
                dir="rtl"
                lang="ar"
                readOnly={readOnly}
                value={transectionData.lastNameAR}
                onChange={(e) =>
                  setTransectionData((prev) => ({
                    ...prev,
                    lastNameAR: e.target.value,
                  }))
                }
                onFocus={() => !readOnly && setActiveField('lastNameAR')}
              />

              <FaKeyboard
                size={30}
                className="ms-2 keyboard-icon"
                style={{ cursor: readOnly ? 'not-allowed' : 'pointer', opacity: readOnly ? 0.45 : 1 }}
                onClick={() => !readOnly && setActiveField('lastNameAR')}
              />
            </div>
          )}
          {/* Address AR */}
          <div className="d-flex align-items-center mt-3">
            <label className="form-label w-25">Address (AR)</label>

            <input
              type="text"
              className="form-control"
              dir="rtl"
              lang="ar"
              readOnly={readOnly}
              value={transectionData.addressAR}
              onChange={(e) =>
                setTransectionData((prev) => ({
                  ...prev,
                  addressAR: e.target.value,
                }))
              }
              onFocus={() => !readOnly && setActiveField('addressAR')}
            />
            <FaKeyboard
              size={30}
              className="ms-2 keyboard-icon"
              style={{ cursor: readOnly ? 'not-allowed' : 'pointer', opacity: readOnly ? 0.45 : 1 }}
              onClick={() => !readOnly && setActiveField('addressAR')}
            />
          </div>
          {/* Keyboard Popup */}
          {activeField && !readOnly && (
            <ArabicKeyboardPopup value={transectionData[activeField]} setValue={handleKeyboardChange} onClose={() => setActiveField(null)} />
          )}
        </div>
      </div>
    </div>
  );
};
export default PersonalDetails;
